import { Component, Input, OnInit } from '@angular/core';
import { SmsTemplate } from '@models/sms/templates';
import { NgbActiveModal, NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SmsService } from '@services/sms.service';
import { SmsTemplateCreateEditModalComponent } from '../create-edit-modal/sms-template-create-edit-modal.component';

@Component({
  selector: 'wsb-insert-tamplate-modal',
  templateUrl: './insert-tamplate-modal.component.html',
  styleUrls: ['./insert-tamplate-modal.component.scss'],
  standalone: false
})
export class InsertTemplateModalComponent implements OnInit {
  @Input() isSmsAdv = false;
  templates: Array<SmsTemplate> = [];
  filteredTemplates: Array<SmsTemplate> = [];

  private confirmModal: NgbModalRef;
  private currentFilter = '';

  constructor(public activeModal: NgbActiveModal, private smsService: SmsService, private modalService: NgbModal) {}

  ngOnInit(): void {
    this.updateSmsTemplateList();
  }

  private updateSmsTemplateList(): void {
    this.smsService.getSmsTemplateList().subscribe(templates => {
      this.templates = templates;
      this.filteredTemplates = this.filterTemplates(templates);
    });
  }

  private filterTemplates(templates: Array<SmsTemplate>): Array<SmsTemplate> {
    if (this.currentFilter.trim() === '') {
      return templates;
    }
    const lowerFilter = this.currentFilter.toLowerCase();
    return templates.filter(t => t.text.toLowerCase().indexOf(lowerFilter) >= 0 || t.name.toLowerCase().indexOf(lowerFilter) >= 0);
  }

  updateTemplateFilter(filter: string) {
    this.currentFilter = filter;
    this.filteredTemplates = this.filterTemplates(this.templates);
  }

  createNewTemplate(): void {
    this.openSmsTemplateCreateEditModal();
  }

  private openSmsTemplateCreateEditModal() {
    const options: NgbModalOptions = {
      size: 'lg'
    };
    const createSmsTemplateModal = this.modalService.open(SmsTemplateCreateEditModalComponent, options);
    createSmsTemplateModal.componentInstance.isSmsAdvTemplate = this.isSmsAdv;
    createSmsTemplateModal.result.then(
      () => {
        this.updateSmsTemplateList();
      },
      () => {}
    );
  }

  sendSmsTemplate(template: SmsTemplate) {
    window.location.href = `/sms/send?atlas_template_id=${template.idTemplate}`;
  }

  closeModal() {
    this.confirmModal.close();
  }
}
